fragment GroupPermissionsFragment on GroupPermissions {
  areGroupsInAccessGroupIdsHierarchy
  updateGroupAttributes
}




fragment accessGroupsFragment on Group {
  id
  name
  type
  parentIds
  hierarchy
  hierarchyIds
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
  permissions {
    ...GroupPermissionsFragment
  }
}



fragment PersonFragmentForTaggedMembersPanel on Person {
  aggregateId
  employeeId
  avatar
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
  tags: appliedTags(filter: $tagFilter) {
    id
    tagId
    type
    displayValue
    isActive
    attributes
    entityTagAttributes
  }
}

fragment PersonFragment on Person {
  address
  country
  city
  aggregateId
  employeeId
  allocations {
    fte
    targetGroupId
  }
  attributes {
    attributeType
    subtype
    value
    id
  }
  avatar
  userAvatarOriginal
  userAvatarCropped
  userAvatarCropData {
    x
    y
    width
    height
  }
  bands
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
  span
  division {
    id
    name
    hierarchy
  }
  managing {
    aggregateId
  }
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
    permissions {
      ...GroupPermissionsFragment
    }
    tags {
      id
      type
      displayValue
      isActive
      attributes
    }
  }
  accessGroups {
    ...accessGroupsFragment
  }
  tags: appliedTags {
    id
    tagId
    type
    displayValue
    isActive
    attributes
    entityTagAttributes
  }
  sourceGroupIds
  permissions {
    isInAccessGroupIdsHierarchy
  }
}

fragment PersonBaseFragment on Person {
  address
  country
  city
  aggregateId
  employeeId
  avatar
  bands
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
}

fragment GlobalSearchPersonBaseFragment on Person {
  ...PersonBaseFragment
  allocations {
    fte
    targetGroupId
  }
  attributes {
    attributeType
    subtype
    value
  }
  division {
    id
    name
    hierarchy
  }
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
  sourceGroupIds
}


# Minimal variant for allocation search - avoids managedByHierarchy.avatar/jobTitle
fragment PersonManagersTagsMinimalFragment on Person {
  managedBy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
    attributes {
      attributeType
      subtype
      value
    }
  }
  managedByHierarchy {
    firstName
    surname
    preferredName
    aggregateId
  }
  tags: appliedTags {
    displayValue
    id
    isActive
    tagId
    type
  }
}

fragment PersonManagersTagsFragment on Person {
  managedBy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
    attributes {
      attributeType
      subtype
      value
    }
  }
  managedByHierarchy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
  }
  tags: appliedTags {
    displayValue
    id
    isActive
    tagId
    type
  }
}


fragment PersonManagerFragment on Person {
  managedBy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
    attributes {
      attributeType
      subtype
      value
    }
  }
}


fragment PersonCardFragmentNoSourceGroupIds on Person {
  aggregateId
  employeeId
  firstName
  surname
  preferredName
  jobTitle
  company
  fte
  bands
  avatar
  attributes {
    attributeType
    subtype
    value
  }
  tags: appliedTags {
    id
    tagId
    type
    displayValue
    isActive
    attributes
    entityTagAttributes
  }
  permissions {
    isInAccessGroupIdsHierarchy
  }
  allocations {
    fte
    targetGroupId
  }
  memberOf {
    id
    name
    type
    hierarchy
    hierarchyIds
  }
}

fragment PersonCardFragment on Person {
  ...PersonCardFragmentNoSourceGroupIds
  sourceGroupIds
}



fragment CommentFragment on Comment {
  id
  threadId
  authorId
  authorTitle
  timestamp
  content
  contentMarkup
  tags
}

query getComments($filters: [[String]]!) {
  result: getCommentsV2(filters: $filters, page: 0, pageSize: 200) {
    comments {
      ...CommentFragment
    }
  }
}

mutation saveComment(
  $threadId: String!
  $tags: [String]!
  $content: String!
  $contentMarkup: String!
) {
  comment: saveComment(
    threadId: $threadId
    content: $content
    contentMarkup: $contentMarkup
    tags: $tags
  ) {
    ...CommentFragment
  }
}

query getCommentCounts($groupId: String, $filters: [[String]]!) {
  counts: getCommentCountsV2(groupId: $groupId, filters: $filters) {
    threadId
    count
  }
}

query getAllocationProjectsWithCommentCounts(
  $filters: [[String]]
  $includeHistoricAllocationProjects: Boolean
  $includeActiveAllocationProjects: Boolean
  $includeForecastAllocationProjects: Boolean
) {
  counts: getCommentCountsByAllocationProjectV2(
    filters: $filters
    includeHistoricAllocationProjects: $includeHistoricAllocationProjects
    includeActiveAllocationProjects: $includeActiveAllocationProjects
    includeForecastAllocationProjects: $includeForecastAllocationProjects
  ) {
    allocationProject {
      id
      allocationName
      startDate
      isActive
      forecast
    }
    count
  }
}

query getPersonTagsVisibleInComments {
  tagTypes: getTagConfigList(
    input: { entityType: person, visibleIn: IndividualsHistory }
  ) {
    id
  }
}



query personForUserQuery {
  person: getPersonForUser {
    ...PersonFragment
    ...PersonManagersTagsFragment
  }
}

query getPersonQuery($aggregateId: String!) {
  person: getPerson(aggregateId: $aggregateId) {
    ...PersonFragment
    ...PersonManagersTagsFragment
    customerEmployeeId
    disabled
    managing {
      ...PersonFragment
      ...PersonManagerFragment
    }
  }
}

query getPeopleByIds($ids: [String!]) {
  people: getPeopleByIds(ids: $ids) {
    ...PersonFragment
    disabled
  }
}

query getPeopleByTagId($id: String!) {
  people: getPeopleByTagId(id: $id) {
    ...PersonCardFragment
  }
}

query getPersonAddressImage(
  $id: String!
  $width: Int
  $height: Int
  $zoom: String
  $includeMarker: Boolean
) {
  getPersonAddressImage(
    id: $id
    width: $width
    height: $height
    zoom: $zoom
    includeMarker: $includeMarker
  )
}

mutation updateCurrentUserMetadata($userMetadata: UserMetadataInput) {
  updateCurrentUserMetadata(userMetadata: $userMetadata)
}

mutation removePlaceholderPerson($personId: ID!) {
  result: removePlaceholderPerson(personId: $personId) {
    aggregateId
    disabled
  }
}

# Used for useSearchPeople hook - minimal fields for search (PersonBaseFragment is full variant in personFragment.graphql)
fragment PersonSearchBaseFragment on Person {
  aggregateId
  avatar
  fte
  jobTitle
  firstName
  surname
  preferredName
  directTeamIds
  teamIds
}

query peopleSearch(
  $searchTerms: [String]
  $searchAfterId: [String]
  $size: Int
) {
  result: searchPeople(
    size: $size
    searchTerms: $searchTerms
    searchAfterId: $searchAfterId
  ) {
    totalCount
    searchAfterId
    people {
      ...PersonSearchBaseFragment
    }
  }
}

query getPersonHistory($input: PersonHistoryInput!) {
  result: getPersonHistory(input: $input) {
    comments {
      ...CommentFragment
    }
  }
}

#-------- TODO: see if we can consolidate this with the above --------
query allocationPeopleSearch(
  $searchTerms: [String]
  $filter: InsightFilter
  $searchAfterId: [String]
  $size: Int
) {
  result: searchPeople(
    size: $size
    searchTerms: $searchTerms
    filter: $filter
    searchAfterId: $searchAfterId
  ) {
    totalCount
    searchAfterId
    people {
      ...PersonFragment
      ...PersonManagersTagsFragment
      isPlaceholder
    }
  }
}

query searchPeopleQuery(
  $filter: InsightFilter
  $size: Int
  $searchTerms: [String]
  $searchAfterId: [String]
) {
  result: searchPeople(
    size: $size
    searchTerms: $searchTerms
    filter: $filter
    searchAfterId: $searchAfterId
    includeTotalCount: true
  ) {
    totalCount
    searchAfterId
    people {
      ...PersonCardFragmentNoSourceGroupIds
      ...PersonManagerFragment
      isPlaceholder
      isVacancy
      isAIAgent
    }
  }
}

query getAllMembersQuery(
  $peopleFilter: InsightFilter
  $vacanciesFilter: InsightFilter
  $aiAgentsFilter: InsightFilter
  $size: Int
  $skipAIAgents: Boolean!
) {
  people: searchPeople(
    size: $size
    filter: $peopleFilter
    searchAfterId: null
    includeTotalCount: true
  ) {
    totalCount
    searchAfterId
    people {
      ...PersonCardFragmentNoSourceGroupIds
      ...PersonManagerFragment
      isPlaceholder
      isVacancy
      isAIAgent
    }
  }
  vacancies: searchPeople(
    size: $size
    filter: $vacanciesFilter
    searchAfterId: null
    includeTotalCount: true
  ) {
    totalCount
    searchAfterId
    people {
      ...PersonCardFragmentNoSourceGroupIds
      ...PersonManagerFragment
      isPlaceholder
      isVacancy
      isAIAgent
    }
  }
  aiAgents: searchPeople(
    size: $size
    filter: $aiAgentsFilter
    searchAfterId: null
    includeTotalCount: true
  ) @skip(if: $skipAIAgents) {
    totalCount
    searchAfterId
    people {
      ...PersonCardFragmentNoSourceGroupIds
      ...PersonManagerFragment
      isPlaceholder
      isVacancy
      isAIAgent
    }
  }
}

query getBasePeopleByIds($ids: [String!]) {
  people: getPeopleByIds(ids: $ids) {
    ...PersonBaseFragment
    disabled
  }
}

query getPeopleByTagIdV2(
  $id: String!
  $limit: Int
  $offset: Int
  $filter: EntitiesByTagIdFilter
  $tagFilter: TagFilter
) {
  result: getPeopleByTagIdV2(
    id: $id
    limit: $limit
    offset: $offset
    filter: $filter
  ) {
    totalCount
    people {
      ...PersonFragmentForTaggedMembersPanel
    }
  }
}

mutation addGroupToAccessGroups($personId: ID!, $groupId: ID!) {
  addGroupToAccessGroups(personId: $personId, groupId: $groupId) {
    ...PersonBaseFragment
    accessGroups {
      ...accessGroupsFragment
    }
  }
}

mutation removeGroupFromAccessGroups($personId: ID!, $groupId: ID!) {
  removeGroupFromAccessGroups(personId: $personId, groupId: $groupId) {
    ...PersonBaseFragment
    accessGroups {
      ...accessGroupsFragment
    }
  }
}
